export default {
  purchaseSurvey: {
    US: '5baba07d2121cf00011a6be2',
    CA: '613741e24538820001a90c3e',
  },
}
